// extracted by mini-css-extract-plugin
export default {"expandable":"Expandable_expandable__tYTZu","expandable__chevron":"Expandable_expandable__chevron__CxKbo","expandable__btn":"Expandable_expandable__btn__J9Lu3"};